import src from "IMAGE";
export default { src, width: 192, height: 200, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRnIAAABXRUJQVlA4TGYAAAAvB8ABAM1VICICHgiADQIAAAD5V08NDiMAQBAQAAAAAAAAAAAAAAAAAAAAACANwUEIAoRIAiiubgsAAIiIHOAdd983tVrCOZQFGKAOwWgeXdWaTJ+JFyc/yHWHVb4tkT84nRxRrQI="};
